"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _clientAwsS = require("@devsta/client-aws-s3");

var _AddPostsModal = _interopRequireDefault(require("../../../common/components/AddPostsModal"));

var _UpdateCampaignModal = _interopRequireDefault(require("../../../common/components/UpdateCampaignModal"));

var _CampaignListItem = _interopRequireDefault(require("./CampaignListItem"));

require("../styles/_manage-campaigns.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ManageCampaigns = /*#__PURE__*/function (_Component) {
  _inherits(ManageCampaigns, _Component);

  function ManageCampaigns(props) {
    var _this;

    _classCallCheck(this, ManageCampaigns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ManageCampaigns).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onListFiltersChange", function (listFilters) {
      _this.setState({
        searchTerm: listFilters.searchTerm
      }, _this.fetchInactiveCampaigns);
    });

    _defineProperty(_assertThisInitialized(_this), "addCoverPhotoUrls", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(campaigns) {
        var apiClient, newCampaigns, withVoidImages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiClient = _this.props.apiClient;
                _context.prev = 1;
                _context.next = 4;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apiClient,
                  dataArray: campaigns,
                  substitutedKeys: ['coverImageKey']
                });

              case 4:
                newCampaigns = _context.sent;
                return _context.abrupt("return", newCampaigns);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                withVoidImages = campaigns.map(function (campaign) {
                  return _objectSpread({}, campaign, {
                    coverPhotoUrl: void 0
                  });
                });
                return _context.abrupt("return", withVoidImages);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "updateCampaign", function (_ref2) {
      var inspirationCampaignId = _ref2.inspirationCampaignId,
          permissions = _ref2.permissions,
          args = _objectWithoutProperties(_ref2, ["inspirationCampaignId", "permissions"]);

      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var updateCampaign, _ref4, data, error;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                updateCampaign = _this.props.updateCampaign;
                _context2.next = 3;
                return updateCampaign({
                  inspirationCampaignId: inspirationCampaignId,
                  input: _objectSpread({}, args)
                });

              case 3:
                _ref4 = _context2.sent;
                data = _ref4.data;
                error = _ref4.error;

                if (!(!data || !data.updateCampaign || error)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return");

              case 8:
                _this.onCampaignUpdated(_objectSpread({}, data.updateCampaign, {
                  permissions: permissions
                }));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "fetchActiveCampaigns", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props, getAllActiveCampaigns, organisationId, _ref6, data, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, getAllActiveCampaigns = _this$props.getAllActiveCampaigns, organisationId = _this$props.organisationId;
              _context3.next = 3;
              return getAllActiveCampaigns({
                organisationId: organisationId
              });

            case 3:
              _ref6 = _context3.sent;
              data = _ref6.data;
              error = _ref6.error;

              if (!(!data || error || !data.getAllActiveCampaigns)) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                error: true
              }));

            case 8:
              _context3.t0 = _this;
              _context3.next = 11;
              return _this.addCoverPhotoUrls(data.getAllActiveCampaigns);

            case 11:
              _context3.t1 = _context3.sent;
              _context3.t2 = {
                activeCampaigns: _context3.t1
              };

              _context3.t3 = function () {
                return _this.addUserImageUrls('activeCampaigns');
              };

              _context3.t0.setState.call(_context3.t0, _context3.t2, _context3.t3);

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchInactiveCampaigns", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var offset,
            postProcessor,
            getCampaigns,
            searchTerm,
            _ref8,
            data,
            error,
            _data$getCampaigns,
            count,
            campaigns,
            newCampaigns,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                offset = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 0;
                postProcessor = _args4.length > 1 ? _args4[1] : undefined;
                getCampaigns = _this.props.getCampaigns;
                searchTerm = _this.state.searchTerm;
                _context4.next = 6;
                return getCampaigns({
                  IS_ACTIVE: false,
                  searchTerm: searchTerm,
                  limit: 10,
                  offset: offset
                });

              case 6:
                _ref8 = _context4.sent;
                data = _ref8.data;
                error = _ref8.error;

                if (!(!data || error || !data.getCampaigns)) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", void _this.setState({
                  error: true
                }));

              case 11:
                _data$getCampaigns = data.getCampaigns, count = _data$getCampaigns.count, campaigns = _data$getCampaigns.campaigns;
                newCampaigns = postProcessor ? postProcessor(campaigns) : campaigns;
                _context4.t0 = _this;
                _context4.t1 = count;
                _context4.next = 17;
                return _this.addCoverPhotoUrls(newCampaigns);

              case 17:
                _context4.t2 = _context4.sent;
                _context4.t3 = {
                  inactiveCount: _context4.t1,
                  inactiveCampaigns: _context4.t2
                };

                _context4.t4 = function () {
                  return _this.addUserImageUrls('inactiveCampaigns');
                };

                _context4.t0.setState.call(_context4.t0, _context4.t3, _context4.t4);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function () {
        return _ref7.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "loadMoreResults", function (_ref9) {
      var currentOffset = _ref9.currentOffset;
      var _this$state$inactiveC = _this.state.inactiveCampaigns,
          oldCampaigns = _this$state$inactiveC === void 0 ? [] : _this$state$inactiveC;
      return _this.fetchInactiveCampaigns(currentOffset, function (newCampaigns) {
        return [].concat(_toConsumableArray(oldCampaigns), _toConsumableArray(newCampaigns));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createNewCampaign", function () {
      _this.setState({
        createNewCampaign: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editCampaign", function (campaign) {
      _this.setState({
        editExistingCampaign: campaign
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPageRef", function (ref) {
      _this._pageRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "getPageRef", function () {
      return _this._pageRef;
    });

    _defineProperty(_assertThisInitialized(_this), "onHideModal", function () {
      _this.setState({
        createNewCampaign: void 0,
        editExistingCampaign: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCampaignUpdated", function (campaign) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          state = _assertThisInitialize.state;

      var _this$state = _this.state,
          activeCampaigns = _this$state.activeCampaigns,
          inactiveCampaigns = _this$state.inactiveCampaigns;

      if (!activeCampaigns || !inactiveCampaigns) {
        return;
      }

      var alreadyActive = activeCampaigns.some(function (_ref10) {
        var inspirationCampaignId = _ref10.inspirationCampaignId;
        return inspirationCampaignId === campaign.inspirationCampaignId;
      });
      var alreadyInactive = inactiveCampaigns.some(function (_ref11) {
        var inspirationCampaignId = _ref11.inspirationCampaignId;
        return inspirationCampaignId === campaign.inspirationCampaignId;
      });

      if (!alreadyActive && !alreadyInactive) {
        return void _this.setState(function (prevState) {
          return {
            inactiveCampaigns: [campaign].concat(_toConsumableArray(prevState.inactiveCampaigns || [])),
            inactiveCount: prevState.inactiveCount + 1,
            campaignId: campaign.inspirationCampaignId,
            promptAddPosts: !!campaign.inspirationCampaignId
          };
        });
      }

      var activeCampaignsTitle = 'activeCampaigns';
      var inactiveCampaignsTitle = 'inactiveCampaigns';
      var currentListKey = alreadyInactive ? inactiveCampaignsTitle : activeCampaignsTitle;
      var targetListKey = campaign.isActive ? activeCampaignsTitle : inactiveCampaignsTitle;
      var currentList = state[currentListKey];
      var targetList = state[targetListKey];
      var index = currentList.findIndex(function (_ref12) {
        var inspirationCampaignId = _ref12.inspirationCampaignId;
        return inspirationCampaignId === campaign.inspirationCampaignId;
      });

      if (targetListKey === currentListKey) {
        var campaigns = _toConsumableArray(targetList);

        var _campaigns$index = campaigns[index],
            _coverImageKey = _campaigns$index.coverImageKey,
            _updatedByUser = _campaigns$index.updatedByUser;
        campaigns.splice(index, 1, _objectSpread({}, campaign, {
          coverImageKey: _coverImageKey,
          updatedByUser: _updatedByUser
        }));
        return void _this.setState(_defineProperty({}, targetListKey, campaigns));
      }

      var newCurrent = _toConsumableArray(state[currentListKey] || []);

      var _ref13 = newCurrent[index] || {},
          coverImageKey = _ref13.coverImageKey,
          updatedByUser = _ref13.updatedByUser;

      newCurrent.splice(index, 1);

      _this.setState(function (prevState) {
        var _ref14;

        return _ref14 = {}, _defineProperty(_ref14, currentListKey, newCurrent), _defineProperty(_ref14, targetListKey, [_objectSpread({}, campaign, {
          coverImageKey: coverImageKey,
          updatedByUser: updatedByUser
        })].concat(_toConsumableArray(prevState[targetListKey] || []))), _defineProperty(_ref14, "inactiveCount", targetListKey === 'inactiveCampaigns' ? prevState.inactiveCount + 1 : prevState.inactiveCount - 1), _ref14;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "triggerAddPosts", function () {
      _this.setState(function (_ref15) {
        var promptAddPosts = _ref15.promptAddPosts;
        return {
          addPosts: promptAddPosts,
          promptAddPosts: void 0
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideAddPostsPrompt", function () {
      _this.setState({
        promptAddPosts: void 0,
        addPosts: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "moveCampaign", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(oldIndex, newIndex) {
        var activeCampaigns, updateActiveCampaignOrder, campaignToMove, _ref17, data, error, campaignsWithCoverPhotos;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                activeCampaigns = _this.state.activeCampaigns;

                if (!(!activeCampaigns || newIndex < 0 || newIndex >= activeCampaigns.length)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                _this.setState({
                  movingCampaign: true
                });

                updateActiveCampaignOrder = _this.props.updateActiveCampaignOrder;
                campaignToMove = activeCampaigns[oldIndex];
                _context5.next = 8;
                return updateActiveCampaignOrder({
                  inspirationCampaignId: campaignToMove.inspirationCampaignId,
                  newIndex: newIndex
                });

              case 8:
                _ref17 = _context5.sent;
                data = _ref17.data;
                error = _ref17.error;

                if (!(!data || !data.updateActiveCampaignOrder || error)) {
                  _context5.next = 13;
                  break;
                }

                return _context5.abrupt("return", void _this.setState({
                  movingCampaign: false
                }));

              case 13:
                campaignsWithCoverPhotos = data.updateActiveCampaignOrder.map(function (campaign) {
                  return _objectSpread({}, campaign, {
                    coverImageKey: (activeCampaigns.find(function (localCampaign) {
                      return localCampaign.inspirationCampaignId === campaign.inspirationCampaignId;
                    }) || {}).coverImageKey
                  });
                });

                _this.setState({
                  movingCampaign: false,
                  activeCampaigns: campaignsWithCoverPhotos
                });

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x2, _x3) {
        return _ref16.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "deleteCampaign", function (campaign) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var deleteCampaign, _ref19, error, _assertThisInitialize2, state, currentList, index, campaigns;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                deleteCampaign = _this.props.deleteCampaign;
                _context6.next = 3;
                return deleteCampaign(campaign.inspirationCampaignId);

              case 3:
                _ref19 = _context6.sent;
                error = _ref19.error;

                if (!error) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return");

              case 7:
                _assertThisInitialize2 = _assertThisInitialized(_this), state = _assertThisInitialize2.state;
                currentList = campaign.isActive ? 'activeCampaigns' : 'inactiveCampaigns';

                if (state[currentList]) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", void 0);

              case 11:
                index = state[currentList].findIndex(function (_ref20) {
                  var inspirationCampaignId = _ref20.inspirationCampaignId;
                  return inspirationCampaignId === campaign.inspirationCampaignId;
                });
                campaigns = _toConsumableArray(state[currentList] || []);
                campaigns.splice(index, 1);
                return _context6.abrupt("return", void _this.setState(_defineProperty({}, currentList, campaigns), function () {
                  (0, _commonReact.notify)({
                    type: 'success',
                    content: "".concat(campaign.name, " successfully deleted")
                  });
                }));

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "addUserImageUrls", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(campaignsKey) {
        var apiClient, campaigns, newCampaigns, withVoidImages;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                apiClient = _this.props.apiClient;
                campaigns = _this.state[campaignsKey];

                if (campaigns.length) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return");

              case 4:
                _context7.prev = 4;
                _context7.next = 7;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apiClient,
                  dataArray: campaigns,
                  substitutedKeys: [{
                    key: 'updatedByUser',
                    subKeys: ['imageUrl']
                  }]
                });

              case 7:
                newCampaigns = _context7.sent;

                _this.setState(_defineProperty({}, campaignsKey, newCampaigns));

                _context7.next = 15;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](4);
                withVoidImages = campaigns.map(function (campaign) {
                  return _objectSpread({}, campaign, {
                    updatedByUser: _objectSpread({}, campaign.updatedByUser, {
                      imageUrl: void 0
                    })
                  });
                });

                _this.setState(_defineProperty({}, campaignsKey, withVoidImages));

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[4, 11]]);
      }));

      return function (_x4) {
        return _ref21.apply(this, arguments);
      };
    }());

    _this.state = {
      error: false,
      inactiveCount: 0,
      createNewCampaign: false,
      editExistingCampaign: void 0,
      movingCampaign: false
    };
    return _this;
  }

  _createClass(ManageCampaigns, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchInactiveCampaigns();
      this.fetchActiveCampaigns();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          history = _this$props2.history,
          createCampaign = _this$props2.createCampaign,
          apiClient = _this$props2.apiClient,
          updateCampaign = _this$props2.updateCampaign;
      var _this$state2 = this.state,
          campaignId = _this$state2.campaignId,
          error = _this$state2.error,
          inactiveCount = _this$state2.inactiveCount,
          inactiveCampaigns = _this$state2.inactiveCampaigns,
          activeCampaigns = _this$state2.activeCampaigns,
          createNewCampaign = _this$state2.createNewCampaign,
          editExistingCampaign = _this$state2.editExistingCampaign,
          promptAddPosts = _this$state2.promptAddPosts,
          addPosts = _this$state2.addPosts,
          movingCampaign = _this$state2.movingCampaign;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      if (!activeCampaigns || !inactiveCampaigns) {
        return _react.default.createElement(_uiKit.Loader, null);
      }

      var numResults = inactiveCount || 0;
      return _react.default.createElement("div", {
        className: "manage-campaigns page",
        ref: this.setPageRef
      }, _react.default.createElement(_AddPostsModal.default, {
        visible: addPosts,
        hideModal: this.hideAddPostsPrompt,
        campaignId: campaignId
      }), _react.default.createElement(_uiKit.BaseModal, {
        visible: promptAddPosts,
        onClose: this.hideAddPostsPrompt
      }, _react.default.createElement("div", {
        className: "manage-campaigns__prompt-add-posts"
      }, _react.default.createElement(_uiKit.Text, {
        heading3: true,
        centered: true
      }, "Do you want to add Inspiration Posts to this campaign?"), _react.default.createElement(_uiKit.Button, {
        onClick: this.triggerAddPosts
      }, "Okay"), _react.default.createElement(_uiKit.Link, {
        onClick: this.hideAddPostsPrompt
      }, "Maybe Later"))), _react.default.createElement(_UpdateCampaignModal.default, {
        visible: createNewCampaign || Boolean(editExistingCampaign),
        createCampaign: createCampaign,
        onCampaignUpdated: this.onCampaignUpdated,
        apiClient: apiClient,
        updateCampaign: updateCampaign,
        hideModal: this.onHideModal,
        campaign: editExistingCampaign
      }), _react.default.createElement(_uiKit.PageHeader, {
        title: "Campaigns",
        subtitle: "Inspiration",
        actionBtnText: "Create Campaign",
        actionBtnOnClick: this.createNewCampaign,
        breadCrumbs: [{
          title: 'Inspiration',
          url: '/inspiration'
        }, {
          title: 'Manage Posts',
          url: '/inspiration/manage'
        }],
        history: history
      }), _react.default.createElement("div", {
        className: "manage-campaigns__content column"
      }, (activeCampaigns.length || inactiveCampaigns.length) && activeCampaigns && inactiveCampaigns ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_uiKit.Text, {
        heading4: true
      }, "Active Campaigns"), _react.default.createElement(_uiKit.List, {
        listKey: "inspirationCampaignId",
        history: history,
        data: activeCampaigns,
        hideFilters: true,
        hideInspiration: true,
        renderListItem: (0, _CampaignListItem.default)({
          history: history,
          onChangeOrder: this.moveCampaign,
          numberOfItems: activeCampaigns ? activeCampaigns.length : 0,
          updateCampaign: this.updateCampaign,
          editCampaign: this.editCampaign,
          deleteCampaign: this.deleteCampaign,
          movingCampaign: movingCampaign
        })
      }), _react.default.createElement(_uiKit.Text, {
        heading4: true
      }, "Inactive Campaigns")) : null, _react.default.createElement(_uiKit.List, {
        onFiltersChange: this.onListFiltersChange,
        listKey: "inspirationCampaignId",
        history: history,
        data: inactiveCampaigns,
        loading: !inactiveCampaigns,
        renderListItem: (0, _CampaignListItem.default)({
          history: history,
          updateCampaign: this.updateCampaign,
          editCampaign: this.editCampaign,
          deleteCampaign: this.deleteCampaign
        }),
        loadMoreResults: this.loadMoreResults,
        totalResults: numResults,
        getInfiniteScrollParent: this.getPageRef,
        hideInspiration: true
      })));
    }
  }]);

  return ManageCampaigns;
}(_react.Component);

exports.default = ManageCampaigns;